import styled from 'styled-components';

export const FormResumoContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;